import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import PublicBookingForm from './PublicBookingForm';
import AdminDashboard from './AdminDashboard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicBookingForm />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;